module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }